module.exports = __webpack_public_path__ + "fonts/Raleway-Bold.24df9add.woff";